import React, { useState } from 'react';
import { KeyIcon, XIcon } from 'lucide-react';
interface PasswordProtectionProps {
  onVerify: () => void;
}
export function PasswordProtection({
  onVerify
}: PasswordProtectionProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = () => {
    if (password === '22348765') {
      setError(false);
      onVerify();
      setPassword('');
    } else {
      setError(true);
    }
  };
  return <div className="fixed inset-0 bg-gray-100 flex items-center justify-center" data-id="element-384">
      <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg" data-id="element-385">
        <div className="flex justify-between items-center mb-4" data-id="element-386">
          <h2 className="text-lg font-medium flex items-center gap-2" data-id="element-387">
            <KeyIcon className="h-5 w-5 text-[#ec8301]" data-id="element-388" />
            Zugriff geschützt
          </h2>
        </div>
        <p className="text-gray-600 mb-4" data-id="element-389">
          Bitte geben Sie das Passwort ein, um auf das System zuzugreifen.
        </p>
        <div className="space-y-4" data-id="element-390">
          <input type="password" value={password} onChange={e => {
          setPassword(e.target.value);
          setError(false);
        }} placeholder="Passwort eingeben" className={`w-full border ${error ? 'border-red-500' : 'border-gray-300'} rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-[#ec8301]`} onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSubmit();
          }
        }} data-id="element-391" />
          {error && <p className="text-red-500 text-sm" data-id="element-392">Ungültiges Passwort</p>}
        </div>
        <div className="mt-6 flex justify-end" data-id="element-393">
          <button onClick={handleSubmit} className="px-4 py-2 bg-[#ec8301] text-white rounded-lg hover:bg-[#ec8301]/90" data-id="element-394">
            Anmelden
          </button>
        </div>
      </div>
    </div>;
}